





















import { defineComponent, PropType, computed } from '@vue/composition-api';
import { Button } from '@hb/coffee';
import useDispatchProcess from '@/hooks/useDispatchProcess';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { UserHomeSceneEnums } from '@/enums/home-type';
import type { UserCreditData } from '@/pages/home/types';
import { isCreditTaskOcrSuspend } from '@/pages/home/utils';
import { TP_HOME_GO_CREDIT_CLICK } from '../../tianqi';

/**
 * 补充资料模块
 * 展示逻辑：极简流程 授信挂起状态（ 流量分发，命中自营 B 在第一位，且有联营导流渠道，自营 B 授信失败，联营||导流未补充资料场景）
 */
export default defineComponent({
  name: 'CreditSupplementary',
  components: {
    Button,
  },
  props: {
    userCreditData: {
      type: Object as PropType<UserCreditData>,
      required: true,
    },
  },
  setup(props) {
    const { creditProcessDispatch } = useDispatchProcess();
    /** 点击补充资料 */
    const onSupplementClick = () => {
      ubtSetupPageButton(
        TP_HOME_GO_CREDIT_CLICK,
        {
          scene: UserHomeSceneEnums.TAGLESS,
        },
      );
      /** 进入补充资料 & 授信流程 */
      creditProcessDispatch();
    };
    /** 补充资料按钮文案 */
    const supplementText = computed(() => {
      const isOcrSuspend = isCreditTaskOcrSuspend(props.userCreditData);
      return isOcrSuspend ? '提交审批' : '加速审批';
    });

    return {
      supplementText,
      onSupplementClick,
    };
  },
});
